import { PrinterX } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall } from "../CommonComponents/CustomHooks";
import { FormButton, InputBox, TextareaBox } from "../CommonComponents/InputBox";

const CancelShipmemnt = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();

    const initialFormData = {
        docketNo: '',
        cancellationreason: '',
    }

    const [formData, setFormData] = useState(initialFormData);

    const handleClear = () => {
        setFormData(initialFormData);
        inputrefs.current['txtDocketNo'].focus()
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Shipment/CancelShipment`, formData)
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data?.focus, inputrefs, handleClear);
    };

    useEffect(() => {
        document.title = `Cancel Shipment`
        inputrefs.current['txtDocketNo'].focus()
    }, [])

    return (
        <>
            <div className='bg-secondary-50 shadow-lg rounded-lg p-3'>

                <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                        <PrinterX className="w-5 h-5 text-[var(--theme-color)]" />
                        <h2 className="text-xl font-semibold text-slate-800 dark:text-slate-100">Cancel Shipment</h2>
                    </div>
                </div>
                <div className="card-body grid grid-cols-1 md:grid-cols-4 gap-4">
                    {/* Docket No */}
                    <InputBox
                        id="txtDocketNo"
                        label="Docket No."
                        required
                        placeholder="Enter Docket No"
                        value={formData.docketNo}
                        onChange={(e) =>
                            setFormData({ ...formData, docketNo: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtCancellationReason']?.focus()
                            }
                        }}
                    />

                    {/* Remarks */}
                    <TextareaBox
                        id="txtCancellationReason"
                        name="cancellationreason"
                        label="Cancellation Reason"
                        required
                        placeholder="Enter Cancellation Reason"
                        value={formData.cancellationreason}
                        divclassname='col-md-12 mt-1 mb-1'
                        rows={3}
                        maxLength={500}
                        inputclassname='form-control'
                        inputrefs={inputrefs}
                        onChange={(e) =>
                            setFormData({ ...formData, cancellationreason: e.target.value })
                        }
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['btnSub']?.focus();
                            }
                        }}
                    />
                </div>

                <div className='card-body'>
                    <FormButton
                        id={'btnSub'}
                        inputrefs={inputrefs}
                        handleSubmit={handleSubmit}
                        Export={false}
                        savetext={'Cancel'}
                        handleClear={handleClear}
                    />
                </div>
            </div>


        </>
    )
}
export default CancelShipmemnt;